import {
  TooltipRenderer,
  Box,
  Button,
  Text,
  IconAdd,
  TextLink,
  PopoverRenderer,
  Stack,
  Inline,
  ResponsiveRender
} from '@machobear/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import config from '@/config'
import { DialogEventHandler } from '@/types'
const { WEB_URL } = config
type ReactNodeNoStrings = ReactElement | boolean | null | undefined

const ButtonWrapper = ({ children }: { children: ReactNodeNoStrings }) => (
  <>
    <ResponsiveRender above="mobile">
      <Inline align="right" space="medium">
        {children}
      </Inline>
    </ResponsiveRender>

    <ResponsiveRender below="tablet">{children}</ResponsiveRender>
  </>
)

export const AssignListingsButton = ({
  contentID,
  showModal,
  disabled
}: {
  contentID: string
  showModal: (id: 'assignListings' | 'removeListings' | 'deleteMessage') => DialogEventHandler
  disabled: boolean
}) => {
  const { t } = useTranslation()
  if (!contentID) {
    return (
      <TooltipRenderer
        id="create_auto_reply_message"
        tooltip={
          <Box paddingY="xxxsmall" justifyContent="center">
            <Text weight="strong" size="small">
              {t(
                'l.settings.view.auto_reply.auto_reply_create_message_alert',
                'Please create a message first.'
              )}
            </Text>
          </Box>
        }
      >
        {({ triggerProps }) => (
          <ButtonWrapper>
            <Box {...triggerProps} cursor="pointer" display="flex">
              <Button
                type="button"
                variant="ghost"
                icon={<IconAdd />}
                onClick={() => showModal('assignListings')()}
                disabled={!contentID}
              >
                {t('l.settings.view.auto_reply.assign_listings', 'Assign Listings')}
              </Button>
            </Box>
          </ButtonWrapper>
        )}
      </TooltipRenderer>
    )
  }
  if (disabled) {
    return (
      <PopoverRenderer
        trigger={({ triggerProps }) => {
          return (
            <ButtonWrapper>
              <Box
                {...triggerProps}
                cursor="not-allowed"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="small"
                background="disabled"
                gap="xsmall"
                paddingY="xsmall"
                paddingX="small"
                role="button"
              >
                <IconAdd tone="disabled" />
                <Text tone="disabled" weight="strong">
                  {t('l.settings.view.auto_reply.assign_listings', 'Assign Listings')}
                </Text>
              </Box>
            </ButtonWrapper>
          )
        }}
      >
        <Box paddingBottom="xxxsmall">
          <Stack space="small">
            <Text size="small">
              {t(
                'r.settings.view.auto_reply.tooltip.content',
                'Need more Auto-Replies? Upgrade to a Growth or Business Plan to unlock unlimited access'
              )}
            </Text>
            <Text weight="strong" size="small">
              <TextLink href={`${WEB_URL}/pricing`} target="_blank">
                {t('common.upgrade_now', 'Upgrade Now')}
              </TextLink>
            </Text>
          </Stack>
        </Box>
      </PopoverRenderer>
    )
  }
  return (
    <ButtonWrapper>
      <Button
        type="button"
        variant="ghost"
        icon={<IconAdd />}
        onClick={() => showModal('assignListings')()}
      >
        {t('l.settings.view.auto_reply.assign_listings', 'Assign Listings')}
      </Button>
    </ButtonWrapper>
  )
}
